// Estimated card heights — keep in sync with QueueNode / DlqNode / LambdaNode styles.
export const EST_SQS_BODY_HEIGHT = 74;
export const EST_DLQ_FOOTER_HEIGHT = 28;
export const EST_MAIN_WITH_DLQ_HEIGHT = EST_SQS_BODY_HEIGHT + EST_DLQ_FOOTER_HEIGHT;
export const EST_LAMBDA_CARD_HEIGHT = 85;
export const EST_SQS_CARD_WIDTH = 170;
export const LAMBDA_TO_MAIN_GAP = 12;
export const COLUMN_STEP = 220;
export const DLQ_TO_FANOUT_GAP = 40;
export const BOTTOM_PADDING = 40;

const MAIN_ROW_Y = 0;
const LAMBDA_ROW_Y = EST_MAIN_WITH_DLQ_HEIGHT + LAMBDA_TO_MAIN_GAP;

const COLUMN_X = {
  A: 0,
  B: COLUMN_STEP,
  C: COLUMN_STEP * 2,
  D: COLUMN_STEP * 3,
  E: COLUMN_STEP * 4,
  F: COLUMN_STEP * 3,
  G: COLUMN_STEP * 4,
  H: COLUMN_STEP * 5,
};

export function getPipelineLayout() {
  const fanoutRowY =
    LAMBDA_ROW_Y + EST_LAMBDA_CARD_HEIGHT + DLQ_TO_FANOUT_GAP;
  const graphHeight = fanoutRowY + EST_MAIN_WITH_DLQ_HEIGHT + BOTTOM_PADDING;

  return {
    mainRowY: MAIN_ROW_Y,
    lambdaRowY: LAMBDA_ROW_Y,
    fanoutRowY,
    graphHeight,
    positions: {
      L: { x: COLUMN_X.A, y: LAMBDA_ROW_Y },
      A: { x: COLUMN_X.A, y: MAIN_ROW_Y },
      B: { x: COLUMN_X.B, y: MAIN_ROW_Y },
      T: { x: COLUMN_X.C, y: LAMBDA_ROW_Y },
      C: { x: COLUMN_X.C, y: MAIN_ROW_Y },
      D: { x: COLUMN_X.D, y: MAIN_ROW_Y },
      E: { x: COLUMN_X.E, y: MAIN_ROW_Y },
      F: { x: COLUMN_X.F, y: fanoutRowY },
      G: { x: COLUMN_X.G, y: fanoutRowY },
      H: { x: COLUMN_X.H, y: fanoutRowY },
    },
  };
}

export function isLambdaStage(stage) {
  return stage?.type === "lambda" || Boolean(stage?.functionName);
}

export function isQueueStage(stage) {
  return Boolean(stage?.queue);
}

export function getLambdaFeedTargets(pipeline) {
  if (!pipeline?.edges || !pipeline?.stages) return new Set();
  const stageByKey = new Map(pipeline.stages.map((s) => [s.key, s]));
  const targets = new Set();
  for (const edge of pipeline.edges) {
    if (isLambdaStage(stageByKey.get(edge.source))) {
      targets.add(edge.target);
    }
  }
  return targets;
}

export function getStageByKey(pipeline, key) {
  return pipeline?.stages?.find((stage) => stage.key === key);
}
